<template>
  <div class="checkbox-button" :class="{ checked }" @click.prevent="onChange">
    <input type="checkbox" :name="groupName" :value="value" :id="value" :checked="checked" />
    <label :for="value">
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  props: ['value'],
  inject: ['groupName', 'groupContext'],
  methods: {
    onChange(e) {
      const value = {
        [this.value]: !this.checked,
      };
      this.groupContext.onChange(value);
      this.$emit('click', e);
    },
  },
  computed: {
    checked() {
      const { value } = this.groupContext;
      return !!value && value[this.value];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.checkbox-button {
  border-radius: 4px;
  margin: 5px;
  color: $text-grey;
  padding: 0 5px;
  background: #fff;
  font-size: 14px;
  height: 32px;
  line-height: 30px;
  transition: color 0.3s, background 0.3s, border-color 0.3s;
  vertical-align: baseline;
  border: 1px solid #d9d9d9;

  &,
  * {
    cursor: pointer;
  }

  input {
    display: none;
  }
}

.checkbox-button:active,
.checked {
  border-color: #3a65f0;
  color: #3a65f0;
}
</style>
